import React, { Component } from 'react'

import TweenMax, { TimelineMax, Expo, Power3, Linear } from 'gsap'
import Scroller from 'src/utils/scroller'
import './styles.scss'
import components from 'src/utils/components'
import { router } from 'router'

export default class Header extends Component {
  constructor() {
    super()
    this.nativeCurrentY = 0
    this.scrollDirection = 0
    this.state = {
      open: false
    }
  }

  componentDidMount() {
    this.initTL()
  }

  initTL() {
    this.tlAnimateMenuLangueInOut = new TimelineMax({
      paused: true
    })

    this.tlAnimateMenuLangueInOut
      .fromTo(
        this.refs.languages,
        1.1,
        {
          y: '-100%'
        },
        {
          y: '0%',
          ease: Power3.easeOut
        },
        0
      )
      .fromTo(
        this.refs.languagesContainer,
        1.1,
        {
          y: '100%'
        },
        {
          y: '0%',
          ease: Power3.easeOut
        },
        0
      )
  }

  onClick = () => {
    window.open(this.props.url)
  }

  onClickLogo = () => {
    Scroller.scrollTo(0, 0.5).then()
  }

  onClickMenu = () => {
    components.allComponents.homeMenuMobile.animateIn()
  }

  onLanguage = () => {
    this.tlAnimateMenuLangueInOut.timeScale(1).play()
  }

  onLeaveLanguage = () => {
    this.tlAnimateMenuLangueInOut.timeScale(2).reverse()
  }

  onClickLanguage = lang => {
    router.goto(`/${lang}`)
  }

  render() {
    return (
      <header ref="header" className="component header">
        <div onClick={this.onClickLogo} className="container-logo">
          <img ref="logo" src={`${process.env.PUBLIC_URL}/img/chaumet.png`} />
        </div>
        <div onClick={this.onClickMenu} className="container-btn-menu">
          <span className="middle" />
          <span className="top" />
          <span className="btm" />
        </div>
        <div onClick={this.onClick} className="container-btn">
          <p className="btn">
            <span className="arrow ">
              <span className="middle" />
              <span className="top" />
              <span className="btm" />
            </span>
            {this.props.content}
          </p>
        </div>
        <span onClick={this.onClick} className="arrow-mobile">
          <span className="middle" />
          <span className="top" />
          <span className="btm" />
        </span>
        <span className="border-btm" />
        <div
          onMouseEnter={this.onLanguage}
          onClick={this.onLanguage}
        className="language">
          <div className="language-container">
            <p className="btn">{this.props.currentLanguage.title}</p>
            <span className="arrow-rotate"> {'<'} </span>
          </div>
        </div>
        <div
          onMouseLeave={this.onLeaveLanguage}
          ref="languages"
        className="languages">
          <div ref="languagesContainer" className="languages-container">
            <div onClick={this.onLeaveLanguage} className="current">
              <p className="btn">{this.props.currentLanguage.title}</p>
              <span className="arrow-rotate"> {'<'} </span>
            </div>
            {this.props.switcher.map((item, i) => {
              return (
                <p
                  onClick={this.onClickLanguage.bind(this, item.lang)}
                  key={`link${i}`}
                className="btn">
                  {item.title}
                </p>
              )
            })}
          </div>
        </div>
      </header>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/Home/components/header/index.js